/* ===========================================================================
   AB Complete lander — behaviors
   Smooth-scroll CTAs → buy box · marquee · video modal · tribe play ·
   benefit/tribe carousels · buy box (flavor/qty/plan, live pricing) ·
   AJAX add-to-cart → open the theme cart drawer.
   Pure vanilla, no deps. Safe if any section is absent.
   =========================================================================== */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    if (cents == null || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    smoothScroll();
    marquee();
    videoModal();
    tribe();
    carousel('.bcols', '.bcols-nav [data-dot]');
    carousel('.tribe__grid', '.tribe-nav .tribe-dot');
    forceLoop();
    heroParallax();
    buyBox();
  });

  /* ---- Hero background parallax ---- */
  function heroParallax() {
    var bg = $('.hero__bg');
    if (!bg) return;
    var sec = bg.closest('section');
    if (!sec) return;
    var ticking = false;
    function update() {
      var rect = sec.getBoundingClientRect();
      var shift = (-rect.top) * 0.28;
      bg.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---- Smooth-scroll any in-page CTA (e.g. → #offer), clearing sticky header -- */
  function smoothScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target = document.getElementById(id.slice(1));
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  /* ---- Marquee: rAF translate loop, wraps at half-width ---------------- */
  function marquee() {
    var track = $('.marquee__track');
    if (!track) return;
    var x = 0;
    function tick() {
      x -= 0.4;
      var half = track.scrollWidth / 2;
      if (half && -x >= half) x += half;
      track.style.transform = 'translateX(' + x + 'px)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---- Shared video modal (.video-trigger[data-video]) ----------------- */
  function videoModal() {
    var modal = $('.video-modal');
    var vid = $('.modal-vid');
    var triggers = $$('.video-trigger');
    if (!modal || !vid || !triggers.length) return;
    function open(url) {
      if (url && vid.getAttribute('src') !== url) vid.src = url;
      modal.style.display = 'flex';
      try { vid.currentTime = 0; } catch (e) {}
      vid.play().catch(function () {});
    }
    function close() { vid.pause(); modal.style.display = 'none'; }
    triggers.forEach(function (t) {
      t.addEventListener('click', function () { open(t.getAttribute('data-video')); });
    });
    var cb = $('.modal-close', modal);
    if (cb) cb.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.style.display === 'flex') close(); });
  }

  /* ---- Tribe tiles: click to play (sound), pause the others ----------- */
  function tribe() {
    var tiles = $$('.tribe-tile');
    tiles.forEach(function (tile) {
      var v = $('.tribe-video', tile);
      var play = $('.tribe-play', tile);
      if (!v || !play) return;
      tile.addEventListener('click', function () {
        if (v.paused) {
          tiles.forEach(function (o) {
            if (o !== tile) { var ov = $('.tribe-video', o), op = $('.tribe-play', o); if (ov) ov.pause(); if (op) op.style.opacity = '1'; }
          });
          v.muted = false; v.play().catch(function () {}); play.style.opacity = '0';
        } else { v.pause(); play.style.opacity = '1'; }
      });
      v.addEventListener('ended', function () { play.style.opacity = '1'; });
      v.addEventListener('pause', function () { play.style.opacity = '1'; });
      v.addEventListener('play', function () { play.style.opacity = '0'; });
    });
  }

  /* ---- Generic mobile carousel dots (benefits, tribe) ------------------ */
  function carousel(gridSel, dotSel) {
    var grid = $(gridSel);
    var dots = $$(dotSel);
    if (!grid || !dots.length) return;
    var cards = Array.prototype.slice.call(grid.children);
    function set(i) {
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.style.width = on ? '22px' : '8px';
        d.style.background = on ? 'var(--terracotta)' : 'var(--bark-mute)';
        d.style.opacity = on ? '1' : '0.45';
      });
    }
    grid.addEventListener('scroll', function () {
      var gr = grid.getBoundingClientRect(), mid = gr.left + gr.width / 2, best = 0, bd = Infinity;
      cards.forEach(function (c, i) { var r = c.getBoundingClientRect(); var dd = Math.abs((r.left + r.width / 2) - mid); if (dd < bd) { bd = dd; best = i; } });
      set(best);
    }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var c = cards[i].getBoundingClientRect(), gr = grid.getBoundingClientRect();
        grid.scrollTo({ left: grid.scrollLeft + (c.left - gr.left) - 24, behavior: 'smooth' });
      });
    });
    set(0);
  }

  /* ---- Force benefit-card videos to autoplay + loop -------------------- */
  function forceLoop() {
    $$('.bcols video').forEach(function (v) {
      v.loop = true; v.muted = true; v.autoplay = true; v.playsInline = true;
      v.addEventListener('ended', function () { v.currentTime = 0; v.play().catch(function () {}); });
      var tryPlay = function () { v.play().catch(function () {}); };
      if (v.readyState >= 2) tryPlay();
      v.addEventListener('loadeddata', tryPlay);
    });
  }

  /* ====================== BUY BOX ====================================== */
  function buyBox() {
    var dataEl = $('#abc-bb-data');
    var form = $('#bbForm');
    if (!dataEl || !form) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var FL = DATA.flavors;
    var QP = DATA.qtyPlans || {};   // quantity -> delivery-cadence plan id

    var BB = { flavor: 'chocolate', qty: 2, plan: 'sub', freqPlanId: null };

    var els = {
      track: $('#bbTrack'), thumbs: $('#bbThumbs'), dots: $('#bbDots'),
      qtyWrap: $('#bbQty'),
      subPrice: $('#bbSubPrice'), subWas: $('#bbSubWas'), subSave: $('#bbSubSave'), subShip: $('#bbSubShip'),
      oncePrice: $('#bbOncePrice'),
      freq: $('#bbFreq'),
      ctaLabel: $('#bbCtaLabel'), ctaPrice: $('#bbCtaPrice'),
      variantId: $('#bbVariantId'), sellingPlan: $('#bbSellingPlan'),
      accIng: $('#bbAccIng'), modalIng: $('#bbModalIng'), nfpImg: $('#bbNfpImg'), nutriTitle: $('#bbNutriTitle'),
      cta: $('#bbStartNow')
    };

    function sz() { return (FL[BB.flavor].sizes[String(BB.qty)]) || {}; }

    // Resolve the subscription plan id + price for a size, honoring the
    // frequency the customer picked (falls back to the size's default plan).
    // The displayed subscribe price is the STANDARD subscription price — the
    // 15%-off-first-3-orders + free-frother promo is applied by the discount
    // code at checkout, not computed here.
    function subFor(s) {
      if (!s) return { id: null, price: null };
      if (BB.freqPlanId && s.plans) {
        for (var i = 0; i < s.plans.length; i++) {
          if (s.plans[i].id === BB.freqPlanId) return { id: s.plans[i].id, price: s.plans[i].price };
        }
      }
      var price = (s.sub != null) ? s.sub : (s.once != null ? Math.round(s.once * 0.9) : null);
      return { id: s.subPlanId || null, price: price };
    }

    /* ---- gallery (rebuilds per flavor) ---- */
    var THUMB_MAX = 7; // total tiles before the rest collapse into a "+N" tile
    function gScrollTo(i) { var s = els.track.querySelectorAll('.bb-slide')[i]; if (s) els.track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
    function thumbBtn(src, i, active) {
      return '<button class="bb-thumb" data-index="' + i + '" type="button" style="width:66px;flex:none;padding:0;border:2px solid ' + (active ? 'var(--terracotta)' : 'var(--cream-line)') + ';border-radius:10px;overflow:hidden;background:none;cursor:pointer;aspect-ratio:1/1;"><img src="' + src + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;"></button>';
    }
    function renderThumbs(expanded) {
      var imgs = FL[BB.flavor].images || [];
      var total = imgs.length;
      var overflow = !expanded && total > THUMB_MAX;
      var shown = overflow ? THUMB_MAX - 1 : total;
      var html = '';
      for (var i = 0; i < shown; i++) html += thumbBtn(imgs[i], i, i === 0);
      if (overflow) {
        var remaining = total - shown; // images folded behind the "+N" tile
        html += '<button class="bb-thumb bb-thumb--more" data-index="' + shown + '" data-more="1" type="button" aria-label="Show ' + remaining + ' more images" style="width:66px;flex:none;padding:0;border:2px solid var(--cream-line);border-radius:10px;overflow:hidden;background:none;cursor:pointer;aspect-ratio:1/1;position:relative;">' +
          '<img src="' + imgs[shown] + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;filter:brightness(.42);">' +
          '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-family:var(--font-ui);font-weight:700;font-size:16px;">+' + remaining + '</span></button>';
      }
      els.thumbs.innerHTML = html;
      $$('.bb-thumb', els.thumbs).forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = +t.dataset.index;
          if (t.dataset.more) { renderThumbs(true); }
          gScrollTo(idx); setGallery(idx);
        });
      });
    }
    function renderGallery() {
      var imgs = FL[BB.flavor].images || [];
      var nfp = FL[BB.flavor].nfp;
      els.track.innerHTML = imgs.map(function (src, i) {
        var isNfp = src === nfp;
        return '<img class="bb-slide' + (isNfp ? ' is-nfp' : '') + '" data-index="' + i + '" src="' + src + '" alt="" style="flex:0 0 100%;scroll-snap-align:center;width:100%;aspect-ratio:1/1;object-fit:cover;display:block;' + (isNfp ? 'cursor:zoom-in;' : '') + '">';
      }).join('');
      renderThumbs(false);
      els.dots.innerHTML = imgs.map(function (src, i) {
        var on = i === 0;
        return '<button class="bb-dot" data-index="' + i + '" type="button" aria-label="Image ' + (i + 1) + '" style="width:' + (on ? '22px' : '8px') + ';height:8px;border-radius:999px;border:none;padding:0;background:' + (on ? 'var(--terracotta)' : 'var(--bark-mute)') + ';opacity:' + (on ? '1' : '.45') + ';cursor:pointer;transition:all .25s var(--ease-out);"></button>';
      }).join('');
      bindGallery();
      setGallery(0);
    }
    function setGallery(idx) {
      $$('.bb-thumb', els.thumbs).forEach(function (t) { if (!t.dataset.more) t.style.borderColor = (+t.dataset.index === idx) ? 'var(--terracotta)' : 'var(--cream-line)'; });
      $$('.bb-dot', els.dots).forEach(function (d, i) {
        var on = i === idx; d.style.width = on ? '22px' : '8px'; d.style.background = on ? 'var(--terracotta)' : 'var(--bark-mute)'; d.style.opacity = on ? '1' : '.45';
      });
    }
    function bindGallery() {
      var slides = $$('.bb-slide', els.track);
      $$('.bb-dot', els.dots).forEach(function (d) { d.addEventListener('click', function () { gScrollTo(+d.dataset.index); setGallery(+d.dataset.index); }); });
      els.track.addEventListener('scroll', function () {
        var mid = els.track.scrollLeft + els.track.clientWidth / 2, best = 0, bd = Infinity;
        slides.forEach(function (s, i) { var c = s.offsetLeft + s.offsetWidth / 2; var dd = Math.abs(c - mid); if (dd < bd) { bd = dd; best = i; } });
        setGallery(best);
      }, { passive: true });
      slides.forEach(function (s) { if (s.classList.contains('is-nfp')) s.addEventListener('click', openNutri); });
    }

    /* ---- ingredient lists + nutrition modal ---- */
    function ingItem(name) {
      return '<li style="display:flex;justify-content:space-between;gap:12px;padding:9px 0;border-bottom:1px solid var(--cream-line);font-size:14px;color:var(--bark-ink);"><span>' + name + '</span></li>';
    }
    function renderIngredients() {
      var list = (FL[BB.flavor].ing || '').split(';').map(function (s) { return s.trim(); }).filter(Boolean);
      var html = list.map(ingItem).join('');
      if (els.accIng) els.accIng.innerHTML = html;
      if (els.modalIng) els.modalIng.innerHTML = html;
      if (els.nfpImg) els.nfpImg.src = FL[BB.flavor].nfp;
      if (els.nutriTitle) els.nutriTitle.textContent = FL[BB.flavor].name;
    }
    var nutriModal = $('#bbNutriModal');
    function openNutri() { if (nutriModal) nutriModal.style.display = 'flex'; }
    function closeNutri() { if (nutriModal) nutriModal.style.display = 'none'; }
    if (nutriModal) {
      $$('[data-bb-nutri-close]', nutriModal).forEach(function (b) { b.addEventListener('click', closeNutri); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNutri(); });
    }

    /* ---- price / plan / cta recompute ---- */
    function recompute() {
      var s = sz();
      var once = s.once;
      var sp = subFor(s);
      var sub = sp.price;
      if (els.subPrice) els.subPrice.textContent = money(sub);
      if (els.subWas) els.subWas.textContent = money(once);
      if (els.subSave) els.subSave.textContent = (once != null && sub != null && once - sub > 0) ? 'You save ' + money(once - sub) : '';
      if (els.subShip) els.subShip.style.display = (BB.qty >= 2 && BB.plan === 'sub') ? '' : 'none';
      if (els.oncePrice) els.oncePrice.textContent = money(once);
      if (BB.plan === 'sub') {
        els.ctaLabel.textContent = 'Subscribe & Save — ';
        els.ctaPrice.textContent = money(sub);
      } else {
        els.ctaLabel.textContent = 'Buy Once — ';
        els.ctaPrice.textContent = money(once);
      }
      // hidden form fields
      els.variantId.value = s.variantId || '';
      els.sellingPlan.value = (BB.plan === 'sub' && sp.id) ? sp.id : '';
      // soldout guard
      if (s.available === false) {
        els.cta.disabled = true; els.cta.style.opacity = '.55'; els.cta.style.cursor = 'not-allowed';
        els.ctaLabel.textContent = 'Sold Out'; els.ctaPrice.textContent = '';
      } else {
        els.cta.disabled = false; els.cta.style.opacity = ''; els.cta.style.cursor = 'pointer';
      }
    }

    /* ---- flavor ---- */
    function setFlavor(f) {
      if (!FL[f]) return;
      BB.flavor = f;
      $$('.bb-flavor').forEach(function (el) {
        var on = el.dataset.flavor === f;
        el.setAttribute('aria-checked', on ? 'true' : 'false');
        el.style.background = on ? 'rgba(190,98,72,.1)' : 'none';
        el.style.borderColor = on ? 'var(--terracotta)' : 'var(--cream-edge)';
        var nm = $('.bb-flavor-nm', el);
        if (nm) nm.style.color = on ? 'var(--terracotta-deep)' : 'var(--bark-ink)';
      });
      renderGallery();
      renderIngredients();
      recompute();
    }
    $$('.bb-flavor').forEach(function (el) {
      el.addEventListener('click', function () { setFlavor(el.dataset.flavor); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setFlavor(el.dataset.flavor); } });
    });

    /* ---- quantity ---- */
    function setQty(q) {
      BB.qty = q;
      // Quantity drives the delivery cadence: 1 bag -> 30-day plan, 2 -> 60, 3 -> 90.
      var mapped = QP[String(q)];
      if (mapped) {
        BB.freqPlanId = parseInt(mapped, 10) || null;
        if (els.freq && BB.freqPlanId) els.freq.value = String(BB.freqPlanId);
      }
      $$('.bb-opt', els.qtyWrap).forEach(function (b) {
        var on = +b.dataset.q === q;
        b.style.background = on ? 'rgba(190,98,72,.1)' : 'none';
        b.style.color = on ? 'var(--terracotta-deep)' : 'var(--bark-ink)';
        b.style.borderColor = on ? 'var(--terracotta)' : 'var(--cream-edge)';
      });
      recompute();
    }
    $$('.bb-opt', els.qtyWrap).forEach(function (b) { b.addEventListener('click', function () { setQty(+b.dataset.q); }); });

    /* ---- plan ---- */
    function setPlan(p) {
      BB.plan = p;
      $$('.bb-plan').forEach(function (el) {
        var on = el.dataset.plan === p;
        el.setAttribute('aria-checked', on ? 'true' : 'false');
        el.style.borderColor = on ? 'var(--terracotta)' : 'var(--cream-edge)';
        el.style.background = on ? 'rgba(190,98,72,.06)' : 'none';
        var ring = $('.bb-radio', el), dot = $('.bb-radio-dot', el), feats = $('.bb-feats', el), fq = $('#bbFreq', el);
        if (ring) ring.style.borderColor = on ? 'var(--terracotta)' : 'var(--cream-edge)';
        if (dot) { dot.style.opacity = on ? '1' : '0'; dot.style.transform = on ? 'scale(1)' : 'scale(0.4)'; }
        if (feats) feats.style.display = on ? 'flex' : 'none';
        if (fq) fq.disabled = !on;
        // Bottom padding is supplied by the extras block ONLY while it's visible
        // (selected sub card). When extras are hidden — deselected sub, or the
        // one-time card which has none — the body must supply the 18px itself.
        var pbody = $('.bb-pbody', el);
        if (pbody) pbody.style.paddingBottom = (on && feats) ? '0px' : '18px';
      });
      recompute();
    }
    $$('.bb-plan').forEach(function (el) {
      el.addEventListener('click', function () { setPlan(el.dataset.plan); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPlan(el.dataset.plan); } });
    });

    /* ---- delivery frequency (subscribe plan): data-driven from real
       selling plans; must not toggle the card when interacted with ---- */
    if (els.freq) {
      ['click', 'mousedown', 'keydown'].forEach(function (ev) {
        els.freq.addEventListener(ev, function (e) { e.stopPropagation(); });
      });
      els.freq.addEventListener('change', function () {
        BB.freqPlanId = parseInt(els.freq.value, 10) || null;
        if (BB.plan !== 'sub') { setPlan('sub'); } else { recompute(); }
      });
    }

    /* ---- accordions ---- */
    $$('.bb-acc-h').forEach(function (h) {
      h.addEventListener('click', function () {
        var panel = h.nextElementSibling, pm = $('.bb-acc-pm', h);
        var open = panel.style.maxHeight && panel.style.maxHeight !== '0px';
        if (open) { panel.style.maxHeight = '0'; if (pm) pm.style.transform = 'none'; h.setAttribute('aria-expanded', 'false'); }
        else { panel.style.maxHeight = panel.scrollHeight + 'px'; if (pm) pm.style.transform = 'rotate(45deg)'; h.setAttribute('aria-expanded', 'true'); }
      });
    });

    /* ---- AJAX add-to-cart → open the cart drawer (UpCart or AfterSell) ----
       UpCart sets `body.upcartPopupShow` when its drawer is open; for AfterSell,
       snippets/cart-drawer-state.liquid sets `body.cart-drawer-open`. We fire the
       events UpCart + generic drawers listen for, click the cart launcher, then
       fall back to /cart only if nothing opened. */
    function isDrawerOpen() {
      return document.body.classList.contains('upcartPopupShow') ||
             document.body.classList.contains('cart-drawer-open') ||
             !!document.querySelector('cart-drawer.active,cart-drawer.is-open,.drawer--is-open');
    }
    function openCartDrawer() {
      // AfterSell only where UpCart is absent: the live theme loads AfterSell's
      // embed too, with no cart published.
      var aftersell = window.aftersell && window.aftersell.cart && window.aftersell.cart.actions;
      if (typeof window.upcartOpenCart !== 'function' && aftersell && typeof aftersell.open === 'function') {
        try { aftersell.refresh(); aftersell.open(); } catch (e) {}
        return;
      }
      ['upcart:open', 'upcart:openCart', 'cart:open', 'cart:refresh', 'cart:build', 'drawer:open', 'cart-drawer:open'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
        window.dispatchEvent(new CustomEvent(n, { bubbles: true }));
      });
      if (window.UpCart && typeof window.UpCart.open === 'function') { try { window.UpCart.open(); } catch (e) {} }
      var drawer = document.querySelector('cart-drawer, cart-notification');
      if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
      var trigger = document.querySelector('#upcart-cart-icon,.upcart-toggle,[data-upcart-toggle],[data-cart-drawer-toggle],#cart-icon-bubble,a[href$="/cart"]');
      if (trigger) { try { trigger.click(); } catch (e) {} }
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = sz();
      if (!s.variantId || s.available === false) { return; }
      var btn = els.cta, label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
      var body = { items: [{ id: s.variantId, quantity: 1 }] };
      var sp = subFor(s);
      if (BB.plan === 'sub' && sp.id) body.items[0].selling_plan = sp.id;
      fetch((form.dataset.cartUrl || '/cart') + '/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
        credentials: 'same-origin'
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          openCartDrawer();
          // UpCart may auto-open via its own add detection; only redirect if no drawer appears.
          setTimeout(function () { if (!isDrawerOpen()) window.location.href = '/cart'; }, 700);
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = label; } });
    });

    /* ---- first paint ---- */
    // (cadence is set by setQty from the quantity->plan map)
    setFlavor('chocolate');
    setQty(2);
    setPlan('sub');
  }
})();
